import { gql } from '@apollo/client';

export const userFragments = {
  userItem: gql`
    fragment userItem on User {
      id
      firstName
      lastName
    }
  `,
};

export const GET_USER_BY_AUTH = gql`
  query userByAuth {
    userByAuth {
      id
      firstName
      lastName
      etrackId
      bun
      email
      canEmulate
      permissions {
        id
        permission {
          id
          permissionId
          name
        }
        scope {
          id
          name
        }
      }
      userPreference {
        unitOfMeasure
        language
      }
      project {
        id
        name
        contextId
        uomType
        projectConfiguration {
          id
          geoLocation {
            latitude
            longitude
          }
          projectLocation {
            minLatitude
            minLongitude
            maxLatitude
            maxLongitude
          }
          weekStartDay
          projectWeeks {
            isCurrent
            weekNumber
            startDate
            endDate
            id
          }
          usersQuantityDisplayToggle
        }
      }
      crewMember {
        id
        firstName
        lastName
        persona
        imageUrl
        shiftType
        supervisor {
          id
          firstName
          lastName
          persona
          imageUrl
          supervisor {
            id
            firstName
            lastName
            persona
            imageUrl
          }
        }
        # TODO:following two are added because in android used it
        crew {
          id
          crewNumber
        }
      }
      facilities {
        id
      }
    }
  }
`;
export const GET_USERS = gql`
  query users($input: UserFilterInput, $paging: PagingInput) {
    users(input: $input, paging: $paging) {
      total
      cursor
      items {
        ...userItem
        roles {
          id
          name
        }
        crewMember {
          id
          persona
          imageUrl
          crew {
            id
            crewNumber
          }
        }
      }
    }
    ${userFragments.userItem}
  }
`;

export const GET_USERS_BY_ROLE = gql`
  query usersByRole($input: UserFilterInput, $paging: PagingInput) {
    users(input: $input, paging: $paging) {
      total
      cursor
      items {
        ...userItem
        email
        bun
        roles {
          id
          name
        }
        etrackId
        phoneNumber
        mobileCarrier
        disciplines {
          id
          name
        }
        crewMember {
          id
          subGroupDescription
        }
      }
    }
    ${userFragments.userItem}
  }
`;

export const GET_USER_BY_IDs = gql`
  query usersByIds($ids: [ID!]!) {
    usersByIds(ids: $ids) {
      id
      firstName
      lastName
      email
      bun
      becImsId
      etrackId
      phoneNumber
      mobileCarrier
      isActive
      updatedAt
      disciplines {
        id
        name
      }
      roles {
        id
        name
      }
      crewMember {
        id
        imageUrl
        subGroupDescription
        persona
      }
      supervisor {
        id
        firstName
        lastName
        bun
        etrackId
      }
      facilities {
        id
        name
      }
      company {
        id
        name
      }
    }
  }
`;

export const UPDATE_USER = gql`
  mutation updateUser($input: UpdateUserInput!) {
    updateUser(input: $input) {
      user {
        roles {
          id
          name
        }
        facilities {
          id
          name
          title
        }
        crewMember {
          id
          discipline
        }
        disciplines {
          id
          name
        }
        company {
          id
          name
        }
        id
        becImsId
        isActive
      }
      error
    }
  }
`;

export const ADD_USER = gql`
  mutation addUser($input: AddUserInput!) {
    addUser(input: $input) {
      user {
        id
        roles {
          id
        }
        disciplines {
          id
        }
        facilities {
          id
        }
      }
      error
    }
  }
`;

export const SUBSCRIPTION_EMPLOYEEE_UPDATED = gql`
  subscription employeeUpdated {
    employeeUpdated {
      crewMemberId
      personaTypeId
    }
  }
`;

export const SAVE_USER_PREFERENCES = gql`
  mutation saveUserPreferences($input: SaveUserPreferencesInput!) {
    saveUserPreferences(input: $input) {
      errors
      user {
        id
        userPreference {
          unitOfMeasure
          language
        }
      }
    }
  }
`;
